export enum Tabs {
  CONVERSATION = 'conversation',
  PROFILE = 'profile',
}
